import React, { useState, useEffect } from 'react';
import './Navbar.css';

const navLinks = [
  { label: 'about', href: '#about' },
  { label: 'experience', href: '#experience' },
  { label: 'projects', href: '#projects' },
  { label: 'skills', href: '#skills' },
  { label: 'achievements', href: '#achievements' },
  { label: 'contact', href: '#contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="nav-inner">
        <a href="#hero" className="nav-logo">
          <span className="logo-bracket">&lt;</span>
          KK
          <span className="logo-bracket"> /&gt;</span>
        </a>

        <div className={`nav-links ${menuOpen ? 'open' : ''}`}>
          {navLinks.map((link, i) => (
            <a
              key={link.label}
              href={link.href}
              className="nav-link"
              style={{ animationDelay: `${i * 0.05}s` }}
              onClick={() => setMenuOpen(false)}
            >
              <span className="nav-num">0{i + 1}.</span>
              {link.label}
            </a>
          ))}
          <a
            href="mailto:krishkumar18022005@gmail.com"
            className="nav-cta"
          >
            hire me
          </a>
        </div>

        <button
          className={`menu-toggle ${menuOpen ? 'open' : ''}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <span /><span /><span />
        </button>
      </div>
    </nav>
  );
}
